import {
  VEG_FLAG,
  VEGAN_FLAG,
  VEG_OPTION,
  VEGAN_OPTION,
  CATEGORIES,
} from "../data/uniqueValues"
import { rawData } from "../data/rawData"
import { categoryResultIdsMapping } from "../data/categoryResultIdsMapping"
import { results } from "../data/results"

export const formatQuizData = (data) => {
  return data.map((d) => {
    // Possible Result Ids in multiple unnamed columns,
    // getting them in a single property
    let allKeys = Object.keys(d)
    const resultIdsKeys = allKeys.filter(
      (key) =>
        key !== "qId" &&
        key !== "question" &&
        key !== "response" &&
        key !== "nextQId" &&
        key !== "categoriesFiltered"
    )
    let possibleResultsIds2 = resultIdsKeys.flatMap((key) => {
      const value = d[key]
      if (typeof value === "string") {
        return d[key].split(",").map((d) => Number(d))
      } else return Number(d[key])
    })
    possibleResultsIds2 = possibleResultsIds2.filter((d) => d !== 0)

    const nextQId = typeof d.nextQId === "number" ? d.nextQId : null

    return {
      qId: Number(d.qId),
      question: String(d.question),
      response: String(d.response),
      possibleResultsIds: possibleResultsIds2,
      categoriesFiltered: d.categoriesFiltered.split(","),
      nextQId,
    }
  })
}

export const formatFinalData = (rawData) => {
  const data = formatQuizData(rawData)
  const allQIds = [...new Set(data.map((d) => d.qId))]
  return allQIds.map((id) => {
    const options = data.filter((d) => d.qId === id)
    return {
      qId: id,
      text: options[0].question,
      categoriesFiltered: options[0].categoriesFiltered,
      options: options.map((option) => ({
        text: option.response,
        nextQId: option.nextQId,
        possibleResultsIds: option.possibleResultsIds,
      })),
    }
  })
}

export const formatUserChoicesData = (data, questionData) => {
  if (data.length === 0) {
    return [formatShowNewQuestion(questionData)]
  }
  const oldQuestion = data[data.length - 1]
  return [oldQuestion, questionData]
}

export const formatShowNewQuestion = (questionData) => ({
  ...questionData,
  showQuestion: true,
  options: questionData.options.map((d, i) => ({
    ...d,
    optionId: i,
    selected: false,
  })),
})

export const applyCriteria = (flag, ids) => {
  if (flag === VEG_FLAG) {
    // Replace all categories except drinks
    const categoriesToModify = CATEGORIES.filter((d) => d !== "drinks")

    const option = rawData.filter((d) => d.response === VEG_OPTION)[0]
    let newIds = [...ids]
    categoriesToModify.forEach((category) => {
      // Get all possible results for particular category
      const resultIds = categoryResultIdsMapping[category]
      // Remove the personalized results for that category
      // that might contain "non-veg" dishes using `resultIds`
      newIds = newIds.filter((id) => !resultIds.includes(id))

      // Get veg results for that particular category
      const vegRecommendationsString = option[category]
      let vegRecommendations = []
      if (typeof vegRecommendationsString === "string") {
        vegRecommendations = vegRecommendationsString
          .split(",")
          .map((d) => Number(d))
      } else {
        vegRecommendations = [Number(vegRecommendationsString)]
      }
      vegRecommendations = vegRecommendations.filter((d) => d !== 0)

      // Add veg recommendations to user's possible results
      newIds = [...newIds, ...vegRecommendations]
    })
    return newIds
  } else if (flag === VEGAN_FLAG) {
    // Replace all categories except drinks
    const categoriesToModify = CATEGORIES.filter((d) => d !== "drinks")

    const option = rawData.filter((d) => d.response === VEGAN_OPTION)[0]
    let newIds = [...ids]
    categoriesToModify.forEach((category) => {
      // Get all possible results for particular category
      const resultIds = categoryResultIdsMapping[category]
      // Remove the personalized results for that category
      // that might contain "non-vegan" dishes
      newIds = newIds.filter((id) => !resultIds.includes(id))

      // Get vegan results for that particular category
      const veganRecommendationsString = option[category]
      let veganRecommendations = []
      if (typeof veganRecommendationsString === "string") {
        veganRecommendations = veganRecommendationsString
          .split(",")
          .map((d) => Number(d))
      } else {
        veganRecommendations = [Number(veganRecommendationsString)]
      }
      veganRecommendations = veganRecommendations.filter((d) => d !== 0)

      // Add vegan recommendations to user's possible results
      newIds = [...newIds, ...veganRecommendations]
    })
    return newIds
  }
}

// Removes options that don't match with previous user choices
export const removeIrrelevantOptions = (question, possibleResultsIds) => {
  // console.log("QUESTION-", question.text)

  // Split user's possible results into category wise
  const categoryWiseUserResultIds = {}
  Object.keys(categoryResultIdsMapping).forEach((category) => {
    categoryWiseUserResultIds[category] = possibleResultsIds.filter((id) =>
      categoryResultIdsMapping[category].includes(id)
    )
  })
  // console.log(
  //   "category wise user's possible results",
  //   categoryWiseUserResultIds
  // )

  const filteredOptions = []
  question.options.forEach((option) => {
    let categoryWiseOptionResultIds2 = {}
    // Get possible results from the option for the
    // categories it filters (categoriesFiltered)
    question.categoriesFiltered.forEach((d) => {
      categoryWiseOptionResultIds2[d] = option.possibleResultsIds.filter((id) =>
        categoryResultIdsMapping[d].includes(id)
      )
    })
    // console.log("OPTION-", option.text)
    // console.log("categories this option filters: ", question.categoriesFiltered)
    // console.log("option's resultIds", categoryWiseOptionResultIds2)

    // If the user's possible result contains at least 1 result id
    // that the option helps in filtering, display that option
    const decider2 = Object.keys(categoryWiseOptionResultIds2).some((d) => {
      const userResultIds2 = categoryWiseUserResultIds[d]
      const filter = categoryWiseOptionResultIds2[d].filter((id) =>
        userResultIds2.includes(id)
      )
      // console.log(`This option filters results in category "${d}" to`, filter)
      return filter.length
    })
    if (
      decider2 ||
      option.text === "Who needs potatoes?" ||
      option.text === "Sweet potatoes only belong in dessert" ||
      option.text === "Skip it, I’ll take my bread in stuffing form" ||
      option.text === "We're not here to eat salad" ||
      option.text === "None needed"
    ) {
      // console.log("DISPLAYING THE OPTION TO USER!")
      filteredOptions.push(option)
    } else {
      // console.log("IGNORING THE OPTION!")
    }
  })
  return {
    ...question,
    options: filteredOptions,
  }
}

export const getNextQuestionWithOptions = (
  nextQuestion,
  filteredPossibleResults,
  nextQId,
  data
) => {
  const nextQuestion2 = removeIrrelevantOptions(
    nextQuestion,
    filteredPossibleResults
  )

  // Start looking from next question, since current
  // question already has no options
  let qId = nextQId + 1
  let newNextQuestion = nextQuestion2
  let skipToResults = false
  if (nextQuestion2.options.length === 0) {
    // console.log("skipping questions...")
    // Keep progressing through the quiz till you get
    // a question with options
    while (qId < 16) {
      const question = data.find((d) => d.qId === qId)

      const formattedQuestion = removeIrrelevantOptions(
        question,
        filteredPossibleResults
      )
      // console.log({ qId, formattedQuestion })

      if (formattedQuestion.options.length > 0) {
        newNextQuestion = formattedQuestion
        break
      }
      // If no questions found, show results
      if (qId === 15 && formattedQuestion.options.length === 0) {
        skipToResults = true
      }
      // Move to next question. Using +1 cauz in this quiz
      // the flow of questions is in +1 format
      qId += 1
    }
  }
  return {
    question: newNextQuestion,
    skipToResults,
  }
}

export const getImagesFromResultIds = (resultIds) => {
  const images = resultIds.flatMap((id) => {
    const { imgURL, imgURL2, imgURL3 } = results.find((d) => d.resultId === id)
    if (imgURL && imgURL2 && imgURL3) return [imgURL, imgURL2, imgURL3]
    else if (imgURL && imgURL2) return [imgURL, imgURL2]
    else return [imgURL]
  })
  return images
}
